// extracted by mini-css-extract-plugin
export default {"container":"Sj-z","blurb":"Tj-z","links":"Uj-z"};